import { ReactComponent as GoodstackDefaultLogo } from '../../assets/images/logos/goodstack-logo.svg'
import { ReactComponent as GoodstackCausesLogo } from '../../assets/images/logos/goodstack-causes-logo.svg'
import { ReactComponent as GoodstackOperationsLogo } from '../../assets/images/logos/goodstack-operations-logo.svg'

export const logosVariants = {
  default: <GoodstackDefaultLogo title="Goodstack" />,
  causes: <GoodstackCausesLogo title="Goodstack for causes" />,
  operations: <GoodstackOperationsLogo title="Goodstack for operations" />,
}
